<template>
  <dialog-wrapper :visible="dialog">
    <v-dialog v-model="dialog" max-width="700">
      <v-card v-if="dialog">
        <v-card-text>
          <v-layout row wrap>
            <template v-if="$vuetify.breakpoint.mdAndUp">
              <v-flex xs12 sm6 class="my-2 px-1">
                <vc-date-picker
                  v-model="selectedDate"
                  mode="date"
                  is-expanded
                  :attributes="attributes"
                  :locale="locale"
                  color="gray"
                  :is-required="true"
                  :first-day-of-week="2"
                  :disabled-dates="{ weekdays: [1, 7] }"
                  :model-config="dateModelConfig"
                />
              </v-flex>
              <v-flex xs12 sm6 class="my-2 px-3">
                <modal-title />
                <modal-providers :loading-providers="loadingProviders" :providers="providers" @selectProvider="selectProvider" />
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 sm6 class="my-2 px-1">
                <modal-title />
                <date-picker class="pl-3 pt-3" @onDateUpdate="(date) => selectedDate = date" />
                <modal-providers :loading-providers="loadingProviders" :providers="providers" @selectProvider="selectProvider" />
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </dialog-wrapper>
</template>

<script>
import gql from 'graphql-tag';
import moment from 'moment';
import { mapGetters } from 'vuex';
import ErrorHandler from '@/services/ErrorHandler';
import DatePicker from '@/components/common/date-picker/DatePicker.vue';
import Title from './Title.vue';
import Providers from './Providers.vue';
import DialogWrapper from '../../common/dialog-wrapper/DialogWrapper.vue';

export default {
  name: 'CopyProviderModal',
  components: {
    'modal-title': Title,
    'modal-providers': Providers,
    'date-picker': DatePicker,
    DialogWrapper,
  },
  data() {
    return {
      dialog: false,
      menu: false,
      loadingProviders: 0,
      attributes: [
        {
          key: 'today',
          highlight: {
            color: 'gray',
            fillMode: 'outline',
          },
          dates: new Date(),
        },
      ],
      dateModelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      selectedDate: moment().format('YYYY-MM-DD'),
    };
  },
  computed: {
    ...mapGetters('userInfoStore', ['locale']),
  },
  methods: {
    selectProvider(provider) {
      this.$emit('providerSelected', provider.id);
      this.dialog = false;
    },
    open() {
      this.dialog = true;
      this.selectedDate = moment().format('YYYY-MM-DD');
    },
    notWeekend(date) {
      if (this.month) {
        return true;
      }

      const day = moment(date).get('day');
      return day !== 6 && day !== 0;
    },
  },
  apollo: {
    $loadingKey: 'loadingProviders',
    providers: {
      fetchPolicy: 'network-only',
      query: gql`query ProvidersCopyingQuery($date: TimelessDate!, $onlyActive: Boolean) {
        providers(date: $date, onlyActive: $onlyActive) {
          id
          color
          name
          categories {
            selections {
              id
            }
          }
        }
      }`,
      variables() {
        return {
          date: this.selectedDate,
          onlyActive: true,
        };
      },
      skip() {
        return !this.selectedDate || !this.dialog;
      },
      error(error) {
        this.providers = null;
        ErrorHandler.handleApolloError(error);
      },
    },
  },
};
</script>
